import {PaymentMethod} from 'grpc-bob/enum_pb';
import invert from 'lodash.invert';

export const PaymentMethodKeyReverse = invert(PaymentMethod);

export const PaymentMethodGateWayMap = {
    0: "ALL",
    1: "ONEPAY",
    2: "CC",
    3: "ALL",
    4: "ALL",
};
